<template>
  <nav class="navbar is-transparent">
    <div class="navbar-brand">
      <router-link
        :to="{ name: 'home' }"
        class="navbar-item"
      >
        <img
          src="@/assets/img/logo.svg"
          width="100px"
          height="100px"
        >
      </router-link>
    </div>
    <ul class="navbar-list">
      <p class="navbar-item">
        <a @click="scrollToId('experiences')">
          Experiences
        </a>
      </p>
      <p class="navbar-item">
        <a @click="scrollToId('projects')">
          Projects
        </a>
      </p>
      <p class="navbar-item">
        <a @click="scrollToId('contact')">
          Contact
        </a>
      </p>
    </ul>
  </nav>
</template>

<script>
export default {
  methods: {
    scrollToId(id) {
      const element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  },
};
</script>
<style scoped lang="scss">

@include tablet {
  .navbar-list > .navbar-item:not(:last-child) {
    margin-right: 3rem;
  }
}

.navbar {
  display: flex;
  padding: 1.5rem 1.5rem;
  align-items: center;

  @include tablet {
    padding: 30px;
  }

  .navbar-list {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;

    @include tablet {
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }

    .navbar-item {
      padding: 0px;

      :hover {
        color: #6A6CA4;
        transition: color .25s ease;
      }

      & > a {
        color: inherit;
        font-weight: inherit;
        font-size: $size-5;

        @include tablet {
          font-size: $size-3;
        }
      }
    }
  }

  .navbar-item {
    img {
      max-height: 100%;
    }
  }
}

</style>
